import _toConsumableArray from "/var/www/pontevedra4picosroad.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/www/pontevedra4picosroad.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { isDefined, makeUseContext } from "../utils.js";
var TimeoutsContext = React.createContext(null);
export var useTimeouts = makeUseContext("useTimeouts", "TimeoutsContext", TimeoutsContext);
export var TimeoutsProvider = function TimeoutsProvider(_ref) {
  var children = _ref.children;
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    timeouts = _React$useState2[0];
  React.useEffect(function () {
    return function () {
      timeouts.forEach(function (tid) {
        return window.clearTimeout(tid);
      });
      timeouts.splice(0, timeouts.length);
    };
  }, [timeouts]);
  var context = React.useMemo(function () {
    var removeTimeout = function removeTimeout(id) {
      timeouts.splice.apply(timeouts, [0, timeouts.length].concat(_toConsumableArray(timeouts.filter(function (tid) {
        return tid !== id;
      }))));
    };
    var setTimeout = function setTimeout(fn, delay) {
      var id = window.setTimeout(function () {
        removeTimeout(id);
        fn();
      }, delay);
      timeouts.push(id);
      return id;
    };
    var clearTimeout = function clearTimeout(id) {
      if (isDefined(id)) {
        removeTimeout(id);
        window.clearTimeout(id);
      }
    };
    return {
      setTimeout: setTimeout,
      clearTimeout: clearTimeout
    };
  }, [timeouts]);
  return React.createElement(TimeoutsContext.Provider, {
    value: context
  }, children);
};